import { render, staticRenderFns } from "./latest-orders-card.vue?vue&type=template&id=910863ce&scoped=true&"
import script from "./latest-orders-card.vue?vue&type=script&lang=js&"
export * from "./latest-orders-card.vue?vue&type=script&lang=js&"
import style0 from "./latest-orders-card.vue?vue&type=style&index=0&id=910863ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910863ce",
  null
  
)

export default component.exports